import { deepMerge } from 'js/utils/Utils'

import Common from 'js/_core/Common'
import scrollHelper from 'js/modules/_base/events/scroll/ScrollHelper'

const defaults = {
  $names: {
    wrapper: 'body',
    target: '[data-menu]',
    trigger: '[data-menu-trigger]',
  },
  className: {
    isOpened: 'is-menu-opened',
  },
  dataName: {
    triggerType: 'menuTrigger',
  },
  attrName: {
    triggerExpanded: 'aria-expanded',
    targetIsHidden: 'aria-hidden',
    controls: 'aria-controls',
  },
  key: {
    esc: 'Escape' || 'escape',
    menu: 'm' || 'M',
    close: 'c' || 'C',
    open: 'o' || 'O',
  },
  fixedBody: true,
}

export default class BaseMenu {
  constructor(options) {
    this.$root = document
    this.$wrapper = null
    this.$target = null
    this.$triggerAll = null

    this.callback = {
      open: async () => {
        await new Promise((resolve) => {
          if (this.$target) {
            this.$target.style.display = 'block'
          }

          resolve()
        })
      },
      close: async (isTransition) => {
        await new Promise((resolve) => {
          if (this.$target) {
            this.$target.style.display = 'none'
          }

          resolve()
        })
      },
    }

    this.isMenuOpened = false
    this.isCloseAnimating = false

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._addEventListeners()
    this._setControls()

    this.close()
  }

  destroy() {
    this._removeEventListeners()
  }

  _set$() {
    this.$wrapper = document.querySelector(this.$names.wrapper)
    this.$target = this.$root.querySelector(this.$names.target)
    this.$triggerAll = this.$root.querySelectorAll(this.$names.trigger)
  }

  _setControls() {
    if (this.$target) {
      const targetId = this.$target.getAttribute('id')
      if (targetId) {
        this.$triggerAll.forEach(($trigger) => {
          $trigger.setAttribute(this.attrName.controls, targetId)
        })
      }
    }
  }

  _isSelectorAll($element) {
    return $element && $element.length
  }

  _addEventListeners() {
    if (this._isSelectorAll(this.$triggerAll)) {
      this.$triggerAll.forEach(($trigger) => {
        $trigger.addEventListener('click', this.onTriggerClick, false)
      })
    }

    window.addEventListener('keydown', this.onKeydown)
  }

  _removeEventListeners() {
    if (this._isSelectorAll(this.$triggerAll)) {
      this.$triggerAll.forEach(($trigger) => {
        $trigger.removeEventListener('click', this.onTriggerClick)
      })
    }

    window.removeEventListener('keydown', this.onKeydown)
  }

  onTriggerClick = (e) => {
    const $trigger = e.target
    const triggerType = $trigger.dataset[this.dataName.triggerType]

    if (triggerType === 'open') {
      if (!this.isMenuOpened) {
        this.open()
      }
    } else if (triggerType === 'close') {
      if (this.isMenuOpened) {
        this.close()
      }
    } else {
      if (!this.isMenuOpened) {
        this.open()
      } else {
        this.close()
      }
    }
  }

  onKeydown = (e) => {
    const key = e.key
    const code = e.code

    switch (key || code) {
      case this.key.esc:
        if (this.isMenuOpened) {
          e.preventDefault()

          this.close()
        }

        break

      //   case this.key.menu:
      //     if (!this.isMenuOpened) {
      //       this.open()
      //     } else {
      //       this.close()
      //     }
      //
      //     break
      //
      //   case this.key.open:
      //     if (!this.isMenuOpened) {
      //       this.open()
      //     }
      //
      //     break
      //
      //   case this.key.close:
      //     if (this.isMenuOpened) {
      //       this.close()
      //     }
      //
      //     break
    }
  }

  async open() {
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        this.isMenuOpened = true
        this.isScrollingFixed = true
        this.$wrapper.classList.add(this.className.isOpened)

        const focusElement = document.activeElement
        if (focusElement) {
          focusElement.blur()
        }

        if (this.fixedBody) {
          Common.scroll.stop(false)
          scrollHelper.stop()
        }

        if (this.$triggerAll && this.$triggerAll.length) {
          this.$triggerAll.forEach(($trigger) => {
            $trigger.setAttribute(this.attrName.triggerExpanded, true)
          })
        }

        if (this.$target) {
          this.$target.setAttribute(this.attrName.targetIsHidden, false)
        }

        this.callback.open().then(() => {
          resolve()
        })
      })
    })
  }

  async close(isTransition = false, useClearClose = true) {
    await new Promise((resolve) => {
      this.isCloseAnimating = true
      this.isMenuOpened = false
      this.isScrollingFixed = false
      this.$wrapper.classList.remove(this.className.isOpened)

      if (useClearClose) {
        this.clearClose()
      } else {
        this.isCloseAnimating = false
      }

      this.callback.close(isTransition).then(() => {
        if (this.$triggerAll && this.$triggerAll.length) {
          this.$triggerAll.forEach(($trigger) => {
            $trigger.setAttribute(this.attrName.triggerExpanded, false)
          })
        }

        if (this.$target) {
          this.$target.setAttribute(this.attrName.targetIsHidden, true)
        }

        resolve()
      })
    })
  }

  clearClose() {
    const focusElement = document.activeElement
    if (focusElement) {
      focusElement.blur()
    }

    if (this.fixedBody) {
      Common.scroll.start()
      scrollHelper.restart()
      this.isCloseAnimating = false
    }
  }

  async pageTransition() {
    if (this.isMenuOpened) {
      await this.close(true)
    } else {
      await new Promise((resolve) => resolve())
    }
  }
}